export default __webpack_public_path__ + "static/media/aideFrance.be1db237.png";